module.exports = __webpack_public_path__ + "media/promo/advent/images/garland-1-bb220161dd28f9f402516261e6016829.png";